import queryString from 'query-string';

export const getHoursTicketReportUrlLink = (startDate, endDate) => {
  const sDate = startDate || '';
  const eDate = endDate || '';
  return queryString.stringify(
    { startDate: sDate, endDate: eDate },
    { sort: false, skipNull: true, skipEmptyString: true },
  );
};
